import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from "ag-grid-community";


@Component({
  standalone: false,
  selector: 'ngb-edit-curtailment-modal-content',
  templateUrl: './edit-curtailment-modal.component.html'     
})


export class NgbEditCurtailmentModalContent {
  @Input() name;
  @Input() user;
  @Input() time = { hour: 13, minute: 30 };
  @Input() date = {};
  public defaultColDef;
  public rowSelection;
  //public rowData: [];

  public gridOptions_EditCurtailmentTime: GridOptions;

  ngOnInit() {
    this.gridOptions_EditCurtailmentTime = <GridOptions>{
      enableSorting: true,
      enableFilter: true
    };
    this.gridOptions_EditCurtailmentTime.domLayout = 'autoHeight';
    this.gridOptions_EditCurtailmentTime.columnDefs = [
      {
        headerName: "",
        field: "select",
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        width:35
      },
      {
        headerName: "Program",
        field: "program",
        width: 100
      },
      {
        headerName: "Sched. End Time",
        field: "end",
        width: 150
      },
      {
        headerName: "Dispatch Location",
        field: "location",
        width: 150
      },
      {
        headerName: "LCG_CODE",
        field: "LCG",
        width: 100
      },
      {
        headerName: "SLAP",
        field: "SLAP",
        width: 100
      },
      {
        headerName: "ABANK #",
        field: "abank",
        width: 165
      }
    ];
    this.defaultColDef = {
      width: 100,
      headerCheckboxSelection: isFirstColumn,
      checkboxSelection: isFirstColumn,
      resizable: true
    };
    this.gridOptions_EditCurtailmentTime.rowSelection = "multiple";

    this.gridOptions_EditCurtailmentTime.rowData = [
      { program: 'SDP', end: '5/6/2019 9:37 AM', location: '7000', LCG:'SDP-C-1', slap:'SLAP_SCEC', abank:'ETIWANDA2'},
      { program: 'SDP', end: '5/6/2019 12:53 AM', location: '5096',LCG:'SDP-C-2', slap:'SLAP_SCEC', abank:'ETIWANDA1' },
      { program: 'SDP', end: '5/6/2019 12:40 AM', location: '5060',LCG:'SDP-C-6', slap:'SLAP_SCEC', abank:'PADUA' },
      { program: 'SDP', end: '5/6/2019 1:00 PM', location: '5070', LCG:'SDP-C-6', slap:'SLAP_SCEC', abank:'VALLEY'},
      { program: 'SDP', end: '5/6/2019 2:00 PM', location: '7002', LCG:'SDP-H-1', slap:'SLAP_SCHD', abank:'VICTOR2'},
      { program: 'SDP', end: '5/6/2019 2:00 PM', location: '8049', LCG:'SDP-H-2', slap:'SLAP_SCHD', abank:'VICTOR1'},
      { program: 'SDP', end: '5/6/2019 2:00 PM', location: '4060', LCG:'SDP-H-3', slap:'SLAP_SCHD', abank:'MWD SYSTEM'},
      { program: 'SDP', end: '5/6/2019 1:00 PM', location: '4200', LCG:'SDP-H-3', slap:'SLAP_SCHD', abank:'ARIZONA PUBLIC SERVICES'}
    ];
  }


  constructor(public activeModal: NgbActiveModal) { }
}
function isFirstColumn(params) {
  var displayedColumns = params.columnApi.getAllDisplayedColumns();
  var thisIsFirstColumn = displayedColumns[0] === params.column;
  return thisIsFirstColumn;
}
